import React from 'react';

export default function WhatsAppFloat() {
  const handleWhatsAppClick = () => {
    const phoneNumber = '919600295627';
    const message = 'Hi Selvarajan, I came across your portfolio and would like to connect!';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={handleWhatsAppClick}>
      <i className="fab fa-whatsapp"></i>
    </div>
  );
}
